// removed by extract-text-webpack-plugin
module.exports = {"meta":"'{\"e\":\".table__head .table__row,n#editbaskettable th\",\"f\":[]}'"};